import Splide from '@splidejs/splide';

const landingCarousel = {
    init: function(){
        const sliders = document.querySelectorAll('.carousel');
        var splide;
            sliders.forEach(splider => {
            // Large carousel for viewports 768px and above
            splide = new Splide(splider, {
                type: 'loop',
                perPage: 1,
                perMove: 1,
                padding: 0,
                start: 0,
                focus: 0,
                pagination: false,
                throttle: 500,
                speed: 1000,
                arrowPath: 'M35,20L5,40L5,0L35,20z',
                classes: {
                    arrows: 'splide__arrows carousel-controls',
                    arrow: 'splide__arrow carousel-arrow',
                    prev: 'splide__arrow--prev carousel-prev',
                    next: 'splide__arrow--next carousel-next',
                },
            });
            splide.mount();
        });
    },
};

export default landingCarousel;
